import React from 'react';
import {
  Box,
  Grid,
  Modal,
  Typography,
  Stack,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';

import config from "../../config/config";


export default function ViewPerk({
  visible,
  onClose,
  perk,
}) {
  const theme = useTheme();

  return (
    <Modal
      open={visible}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', md: '510px'},
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          maxHeight: '95%',
          overflowY: 'auto',
          '::-webkit-scrollbar': {
            width: '12px',
          },
          '::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          '::-webkit-scrollbar-thumb': {
            borderRadius: '6px',
            border: '3px solid transparent',
            backgroundClip: 'content-box',
            backgroundColor: '#c1c1c1',
          },
          '&:focus-visible': {
            outline: 'none',
          }
        }}>
        <Grid sx={{ margin: 'auto', p: 6, backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d' }}>
          <CloseIcon
            onClick={onClose}
            sx={{
              color: theme.palette.mode === 'light' ? '#181c32' : '#fff',
              position: 'absolute',
              right: '16px',
              top: '16px', 
              display: { md: 'none' }
            }}
          /> 
          <Typography id="modal-modal-title" sx={{ fontSize: '32px', fontWeight: 700, lineHeight: '1em' }}>
            {perk?.title}
          </Typography>
          <Typography sx={{ fontSize: '14px', fontWeight: 500, whiteSpace: 'pre-line', mt: 1.5, mb: 1.5 }}>
            {perk?.summary}
          </Typography>
          <Box
            component="img"
            src={`${config.SERVER_BASE_URL}/${perk?.featuredImage}`}
            sx={{ width: '100%', maxHeight: '225px', objectFit: 'cover', borderRadius: '8px' }}
          />
          <Typography sx={{ fontSize: '13px', fontWeight: 400, whiteSpace: 'pre-line', mt: 1.5 }}>
            {perk?.description}
          </Typography>
          <Stack direction="row" justifyContent="space-between" sx={{ mt: 1.5 }}>
            <Box>
              <Typography sx={{ fontSize: '12px', fontWeight: 600, mt: 1 }}>
                Valid Until:
              </Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: 400, lineHeight: '18px' }}>
                {moment(perk?.expiryDate).format('DD MMM YYYY')}
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: '12px', fontWeight: 600, mt: 1 }}>
                Valid Locations:
              </Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: 400, lineHeight: '18px' }}>
                {perk?.location}
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: '12px', fontWeight: 600, mt: 1 }}>
                Requirement:
              </Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: 400, lineHeight: '18px' }}>
                {perk?.requirement}
              </Typography>
            </Box>
          </Stack>
          <Typography sx={{ fontSize: '12px', lineHeight: '18px', mt: 3 }}>
            To activate this perk, make a booking through my form.
          </Typography>
        </Grid>
      </Box>
    </Modal>
  );
}

ViewPerk.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
